<script>
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import sl from '@/Prevodi/TwoFactorAuth-sl.json'
import en from '@/Prevodi/TwoFactorAuth-en.json'
import it from '@/Prevodi/TwoFactorAuth-it.json'
export default {
  components: {
    Notification,
  },
  props: {
    UserID: String,
    FullUser: Object,
  },
  data() {
    return {
      enabled: false,
      secret: '',
      code: '',
      qr: '',
      showSettings: false,
      isGenerating: false,
      isReseting: false,
      showSecret: false,
      ShowNoti: false,
      text: '',
      types: '',
    }
  },
  created() {
    // await this.loadTranslations('sl', './src/prevodi/TwoFactorAuth-sl.json');
    // await this.loadTranslations('en', './src/prevodi/TwoFactorAuth-en.json');
    // await this.loadTranslations('it', './src/prevodi/TwoFactorAuth-it.json');
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetStatus();
  },
  methods: {
    GetStatus() {
      axios.get('./api/prijava/multiauth/status/', {withCredentials: true}).then((response) => {
        this.enabled = response.data.status;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = this.$t('obvestila.napakaBranja');
        } else {
          this.text = this.$t('obvestila.napakaBranja');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    OpenSettings() {
      this.showSettings = !this.showSettings;
    },
    Generate() {
      this.isGenerating = true;
      axios.post('./api/prijava/multiauth/generiraj/', {withCredentials: true}).then((response) => {
        this.secret = response.data.secret;
        this.qr = response.data.qr;
        const input = document.querySelector('[autocomplete=one-time-code]');
        input.addEventListener('input', () => input.style.setProperty('--_otp-digit', input.selectionStart));
        $('#code').focus();
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = this.$t('obvestila.napakaBranja');
        } else {
          this.text = this.$t('obvestila.napakaBranja');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Validate() {
      if (this.code === '') {
        this.text = this.$t('obvestila.napakaInputa');
        this.types = 'Napaka';
        this.ShowNoti = true;
        return;
      }
      var podatki = new URLSearchParams();
      podatki.append('validacijska', this.code);
      podatki.append('skrivnost', this.secret);
      axios.post('./api/prijava/multiauth/validiraj/', podatki, {withCredentials: true}).then((response) => {
        this.text = this.$t('obvestila.vklopUspesen');
        this.types = 'Uspešno';
        this.ShowNoti = true;
        this.enabled = true;
        this.secret = '';
        this.qr = '';
        this.isGenerating = false;
        this.isReseting = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = this.$t('obvestila.niUjemanja');
        } else {
          this.text = this.$t('obvestila.napakaBranja');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    DisableAuth() {
      this.text = this.$t('obvestila.vprasanjeIzklopa');
      this.types = 'Vprašanje';
      this.ShowNoti = true;
    },
    Disable() {
      this.isGenerating = true;
      axios.post('./api/prijava/multiauth/izklopi/', {withCredentials: true}).then((response) => {
        this.text = this.$t('obvestila.izklopUspesen');
        this.types = 'Uspešno';
        this.ShowNoti = true;
        this.enabled = false;
        this.isGenerating = false;
      }).catch((napaka) => {
        this.isGenerating = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = this.$t('obvestila.napakaBranja');
        } else {
          this.text = this.$t('obvestila.napakaBranja');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    ResetToken() {
      axios.get('./api/prijava/multiauth/status/', {withCredentials: true}).then((response) => {
        this.secret = response.data.secret;
        this.qr = response.data.qr;
        this.isReseting = true;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = this.$t('obvestila.napakaBranja');
        } else {
          this.text = this.$t('obvestila.napakaBranja');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <!--       <div class="drop-down-icon text-black" @click.prevent="OpenSettings()">
          <i v-show="!showSettings" class="fas fa-chevron-right"></i>
          <i v-show="showSettings" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" type="text" id="Skupno" @click.prevent="OpenSettings()">{{$t('labels.buttons.odpri')}}</button> -->
  <transition name="fade">
    <div class="container p-2 gap-2 d-flex justify-content-center">
      <div class="container row">
        <label class="modern-form-label" for="password"> {{enabled ? $t('labels.nastavljeno') : $t('labels.niNastavljeno')}} <i class="fas fa-check" :class="{'fa-check': enabled, 'fa-times': !enabled, 'text-success': enabled, 'text-danger': !enabled}"></i></label>
        <div class="modern-section-body">
          <div v-if="!enabled" class="modern-form-group">
            <div class="modern-form-actions">
              <button type="button"
                      class="btn btn-primary"
                      @click.prevent="Generate()"
                      :disabled="isGenerating">
                <i class="far fa-check-square" v-if="!isGenerating"></i>
                <i class="far fa-check-square fa-spin" v-if="isGenerating"></i>
                <span v-if="isGenerating"> {{$t('labels.buttons.generiranje')}}</span>
                <span v-else> {{$t('labels.buttons.vklopi')}}</span>
              </button>
            </div>
            <div v-if="isGenerating" class='modern-form-group'>
              <p class='modern-form-label'>{{$t('labels.skeniraj')}}</p>
            </div>
            <div v-if="isGenerating" class='modern-form-group text-center'>
              <img :src="qr">
              <!-- VNOS KODE IZ AVTENTIKATORJA -->
              <hr />
              <p class='modern-form-label' @click.prevent='showSecret = !showSecret' v-if="!showSecret">{{$t('labels.kodaNiVidna')}}</p>
              <p class='modern-form-label' @click.prevent='showSecret = !showSecret' v-else >Skrij kodo <i class='fas fa-times'></i></p>
              <p class='modern-form-label' v-if="showSecret">{{$t('labels.prepisi')}} <strong>{{secret}}</strong></p>
              <!-- VNOS KODE IZ AVTENTIKATORJA -->
              <hr />
            </div>
            <div  v-if="isGenerating" class='modern-form-group'>
              <!-- <p class='modern-form-label'>Vnesite kodo, ki je izpisana v vašem avtentikatorju</p> -->
              <label :class="{ 'modern-label-hidden': code.length > 0 }" class="modern-form-label" for="code">{{$t('labels.vnesiKodo')}}</label>
              <!-- <input class="modern-form-input" autocomplete="one-time-code" type="number" max="999999" id="code" v-model="code" required /> -->
              <input type="text" autocomplete="one-time-code" inputmode="numeric" maxlength="6" pattern="d{6}" id="code" v-model="code"/>
            </div>
            <div class="modern-form-actions" v-if="isGenerating">
              <button class="modern-btn modern-btn-primary" @click.prevent="Validate()">
                <i class="fas fa-key"></i>
                {{$t('labels.buttons.potrdiKodo')}}
              </button>
            </div>
          </div>
          <div v-else class='modern-form-group'>
            <div class="modern-form-actions">
              <button type="button"
                      class="btn btn-danger"
                      @click.prevent="DisableAuth()"
                      :disabled="isGenerating">
                <i class="fas fa-times" v-if="!isGenerating"></i>
                <i class="fas fa-times fa-spin" v-if="isGenerating"></i>
                <span v-if="isGenerating">{{$t('labels.buttons.deaktivacija')}}</span>
                <span v-else> {{$t('labels.buttons.izklopi')}}</span>
              </button>
            </div>
            <div class="modern-form-actions">
              <button type="button"
                      class="btn btn-primary"
                      @click.prevent="ResetToken()"
                      :disabled="isReseting">
                <i class="fas fa-sync" v-if="!isReseting"></i>
                <i class="fas fa-sync fa-spin" v-if="isReseting"></i>
                <span v-if="isReseting">{{$t('labels.buttons.ponastavljanje')}}</span>
                <span v-else> {{$t('labels.buttons.ponastavi')}}</span>
              </button>
            </div>
            <div v-if="isReseting" class='modern-form-group'>
              <p class='modern-form-label'>{{$t('labels.skeniraj')}}</p>
            </div>
            <div v-if="isReseting" class='modern-form-group text-center'>
              <img :src="qr">
              <!-- VNOS KODE IZ AVTENTIKATORJA -->
              <hr />
              <p class='modern-form-label' @click.prevent='showSecret = !showSecret' v-if="!showSecret">{{$t('labels.kodaNiVidna')}}</p>
              <p class='modern-form-label' @click.prevent='showSecret = !showSecret' v-else >{{$t('labels.skrij')}} <i class='fas fa-times'></i></p>
              <p class='modern-form-label' v-if="showSecret">{{$t('labels.prepisi')}} <strong>{{secret}}</strong></p>
              <!-- VNOS KODE IZ AVTENTIKATORJA -->
              <hr />
            </div>
            <div  v-if="isReseting" class='modern-form-group'>
              <!-- <p class='modern-form-label'>Vnesite kodo, ki je izpisana v vašem avtentikatorju</p> -->
              <label :class="{ 'modern-label-hidden': code.length > 0 }" class="modern-form-label" for="code">{{$t('labels.vnesiKodo')}}</label>
              <!-- <input class="modern-form-input" autocomplete="one-time-code" type="number" max="999999" id="code" v-model="code" required /> -->
              <input type="text" autocomplete="one-time-code" inputmode="numeric" maxlength="6" pattern="d{6}" id="code" v-model="code"/>
            </div>
            <div class="modern-form-actions" v-if="isReseting">
              <button class="modern-btn modern-btn-primary" @click.prevent="Validate()">
                <i class="fas fa-key"></i>
                {{$t('labels.buttons.potrdiKodo')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <Transition name="fade">
    <Notification class="top-0" v-if="ShowNoti" :message="this.text" :type="this.types"  @da="Disable()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
</template>